import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {flatMap, ListItemControl, UiBaseControl} from '../../../models/uiArtefakt';

@Component({
    selector: 'lv-listenelement',
    templateUrl: './listenelement.component.html',
    styleUrls: ['./listenelement.component.scss'],
    standalone: false
})
export class ListenelementComponent implements AfterViewInit{

  private _uiArtefakt: ListItemControl;

  constructor(private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): ListItemControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ListItemControl) {
    this._uiArtefakt = uiArtefakt;
    if (this._uiArtefakt.Identifikator.indexOf('@') >= 0) {
      flatMap(this._uiArtefakt.UIArtefakt).forEach(artefakt =>
          (artefakt as UiBaseControl).ReferenzListItemKey = this._uiArtefakt.UniqueTrackingID);
    }
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }
}
